/**
 * @member {string} access_token
 * @member {string} expires_in
 * @member {string} refresh_token
 */
export class AccessTokenDTO {
  constructor ({ access_token, expires_in, refresh_token }) {
    let properties = {
      configurable: false,
      enumerable: true,
      writable: false
    }
    Object.defineProperty(this, 'access_token', Object.assign({ value: access_token }, properties));
    Object.defineProperty(this, 'expires_in', Object.assign({ value: expires_in }, properties));
    Object.defineProperty(this, 'refresh_token', Object.assign({ value: refresh_token }, properties));
    Object.freeze(this);
  }

  access_token;

  expires_in;

  refresh_token;
}
